export enum ReceiveAndSignAttachmentProgress {
    Attach,
    Sign
}